<template>
    <header class="bg-white py-0 shadow-custom sticky top-0 left-0 w-full z-50">
      <div class="container-fluid !p-0">
        <div class="flex justify-between items-center px-0 xl:px-[0] flex-col-reverse sm:flex-row gap-4 sm:gap-0 bg-white">
          <div class="user flex justify-start items-start lg:items-center gap-3 border-t border-border py-4 lg:px-[30px] px-[16px] bg-white -mt-1">
          
            <a href="index.html" v-if="opt_type == 'mdsid'" class="py-4 lg:py-0 sm:pe-[16px] lg:pe-[30px] flex items-center justify-center md:justify-end relative bg-white w-full md:w-6/12 lg:w-auto">
            <img src="@/assets/images/seiulogo.jpg" alt="logo" width="120" height="120"/>
          </a>
            <span class="w-[50px] h-[50px] bg-primary flex rounded-md items-center justify-center shrink-0">
              <img src="@/assets/images/user.svg" alt="user" />
            </span>
           <div v-if="opt_type != 'general'">
              <h6 class="card-title !mb-0">New Member Enrollment Form</h6>
              <p class="content !mb-0">Thank you for your interest in U.S. Legal. To enroll, please proceed with completing the application.</p>
            </div>
             <div v-if="opt_type == 'general'">
              <h6 class="card-title !mb-0">New Member Enrollment Form</h6>
              <p class="content !mb-0">This form is to enroll directly with us utilizing a credit card pay method.</p>
              <p class="content !mb-0">If your company/group currently sponsors our legal plans as a voluntary benefit, please check with your Human Resources/Benefits Department to confirm how to enroll.</p>
            </div>
          </div>
          <a href="index.html" class="py-4 lg:py-0 sm:pe-[16px] lg:pe-[30px] flex items-center justify-center md:justify-end relative bg-white w-full md:w-6/12 lg:w-auto">
              <img src="@/assets/images/USL_bridge_stacked_positive.png" alt="logo" class="logo-css" />
            </a>
        </div>
      </div>
    </header>
  </template>
  
  <script>
  import { useStore } from 'vuex'; // Import the `useStore` hook from Vuex
  import { computed } from 'vue';
  export default {
    name: "HeaderComponent",
    setup() {
      const store = useStore(); // Access the Vuex store
      const opt_type = computed(() => store.state.opt_type)
      return {
        opt_type
      };
    }
  };
  </script>
  
  <style scoped>
  /* Add component-specific styles here if needed */
  </style>
  